import { ZfStack, ZfTooltip } from '@zafire/react';
import moment from 'moment/moment';
import type { FunctionComponent } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { partnerNodeSize } from '../../config/constants';
import type { PartnerNodeData } from '../../interfaces';
import { GenderIcon } from './gender-icon';

interface IPartnerNodeContentProps {
    data: PartnerNodeData;
    isDeceased: boolean;
    isHovered: boolean;
}

export const PartnerNodeContent: FunctionComponent<IPartnerNodeContentProps> = ({ data, isDeceased, isHovered }) => {
    const { t } = useTranslation();

    const getYearFromDate = (date?: string) => (date ? `${moment(date).year()}` : '');

    const nationalityText = useMemo(
        () => t('familyTreeNodeNationality') + (data.nationalities.length ? `${data.nationalities.join(', ')}` : '-'),
        [data.nationalities, t],
    );

    return (
        <div className="partner-node-content">
            <GenderIcon gender={data.gender} isDisabled={isDeceased} isHovered={isHovered} />
            <span className="partner-node-name" style={{ maxWidth: `calc(${partnerNodeSize.width}px - var(--padding-horizontal-md))` }}>
                {data.title} {data.firstName} {data.middleName} {data.lastName}
            </span>
            <ZfStack>
                <span>
                    {t(isDeceased ? 'familyTreeNodeDeceasedIn' : 'familyTreeNodeBornIn')}
                    {getYearFromDate(isDeceased ? data.dateOfDeath : data.dateOfBirth)}
                </span>
                <span>
                    {t('familyTreeNodeDomicile')}
                    {data.mainDomicile ? `${data.mainDomicile}` : '-'}
                </span>
                {data.nationalities.length > 3 ? (
                    <ZfTooltip side="top" alignment="center" text={data.nationalities.join(', ')}>
                        <span
                            slot="anchor"
                            className="nationality-list--overflow"
                            style={{ maxWidth: `calc(${partnerNodeSize.width}px - var(--padding-horizontal-md))` }}
                        >
                            {nationalityText}
                        </span>
                    </ZfTooltip>
                ) : (
                    <span>{nationalityText}</span>
                )}
            </ZfStack>
        </div>
    );
};
